import React from "react";

import { StreamingEuStep } from "./models";
import StreamingEuPage from "./StreamingEuPage";

const StreamingEuEmailVerifyPage = () => (
  <StreamingEuPage initialStep={StreamingEuStep.EmailVerify} />
);

export default StreamingEuEmailVerifyPage;
